import React from 'react';
const Footer = (props) => {
  return (
    <>
      <footer className="pt-16">
        <div className="container mx-auto">
          <div
            className="border-t-4 border-gradient rounded-lg"
            style={{
              borderImage: props.darkMode
                ? 'linear-gradient(to right, #7f1d1d, #f97316) 1'
                : 'linear-gradient(to right, #a855f7, #6366f1) 1',
            }}
          >
            <div className="text-center p-4">
              <h3 className={`${props.darkMode ? 'text-white' : 'text-gray-600'}`} style={{ display: 'inline', marginRight: '10px' }}>
                AM-Dev
              </h3>
              <p className={`${props.darkMode ? 'text-white' : 'text-gray-600'} inline`}>
                © {new Date().getFullYear()} Arsal Mehmood. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
   
    </>
  );
};

export default Footer;
